import { useMutation, useQuery } from "@tanstack/react-query";
import { Col, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { ServicePartnerTagDetailCard } from "./components/ServicePartnerTagDetailCard";
import {
  deleteServicePartnerTagById,
  fetchServicePartnerTagById,
} from "@/lib/api/resources/servicePartnerTags.ts";

export const ServicePartnerTagDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const servicePartnerTagQuery = useQuery({
    queryKey: ["service-partner-tags", id],
    queryFn: () => fetchServicePartnerTagById(id),
  });

  const deleteServicePartnerTagMutation = useMutation({
    mutationFn: () => deleteServicePartnerTagById(id),
    onSuccess: () => {
      navigate(`/service-partners/tags`);
      message.success("Tag succesvol verwijderd");
    },
    onError: () =>
      message.error("Er is een fout opgetreden bij het verwijderen van de tag"),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnerTagDetailCard
            servicePartnerTag={servicePartnerTagQuery.data}
            isLoading={servicePartnerTagQuery.isLoading}
            deleteMutation={deleteServicePartnerTagMutation}
          />
        </Col>
      </Row>
    </div>
  );
};
